<template>
  <b-field label="Options" horizontal>
    <div class="block">
      <b-checkbox v-model="data" native-value="bets">Bets</b-checkbox>
      <b-checkbox v-model="data" native-value="transactions">Transactions</b-checkbox>
    </div>
  </b-field>
</template>

<script>
export default {
  name: 'intercom-options',
  props: ['value'],
  computed: {
    data() {
      return this.value || []
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Frontend/IntercomOptions.vue